<template>
    <AdUnitHeader
            :name="name"
            @provideMoreDetails="exportProvideMoreDetails"
    ></AdUnitHeader>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import AdUnitHeader from 'monetize/adUnitSettings/Header.vue';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = [];

export default {
    name: 'AdUnitSettingsHeaderEx',
    mixins: [
        eventBus('ad-unit-settings-header'),
        externalParsedProps(AdUnitHeader.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(AdUnitHeader.props, parsedProps),
    methods: {
        exportProvideMoreDetails(data) {
            this.$emit('provideMoreDetails', data);
        }
    },
    components: { AdUnitHeader }
};
</script>
